import React from 'react';
const points = [{
  num: '01',
  title: 'El trabajo no termina nunca.',
  desc: 'Llegas a casa agotado después de clase y aún debes preparar las fichas y ejercicios del día siguiente.'
}, {
  num: '02',
  title: 'Te faltan herramientas visuales.',
  desc: 'Sabes que la matemática entra por los ojos, pero no tienes tiempo de diseñar materiales profesionales para cada tema.'
}, {
  num: '03',
  title: 'El peso de la diversidad del aula.',
  desc: 'Te cuesta adaptar el mismo tema para los alumnos que van más lento y los que necesitan más reto.'
}, {
  num: '04',
  title: 'Buscas excelencia y reconocimiento.',
  desc: 'Quieres ser el docente que siempre tiene el material más innovador, claro y efectivo de la escuela.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-139">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-140"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-141">
        <div className="text-center mb-12" data-id="element-142">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-143">
            👀 ¿Reconoces estas escenas?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-144">
            MegaPack Matemática Lista™ es para ti si eres docente de Elemental
            / Primaria / Básica y vives esto:
          </p>
        </div>

        <div className="space-y-4" data-id="element-145">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/90 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group shadow-lg" data-id="element-146">
              <span className="text-primary font-black text-2xl sm:text-3xl flex-shrink-0 leading-none mt-0.5" data-id="element-147">
                {point.num}
              </span>
              <div data-id="element-148">
                <h3 className="text-text-main text-lg sm:text-xl font-bold mb-1.5" data-id="element-149">
                  {point.title}
                </h3>
                <p className="text-text-sec text-base font-medium leading-relaxed" data-id="element-150">
                  {point.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Closing line */}
        <p className="text-center text-text-main font-bold text-lg sm:text-xl mt-10" data-id="element-151">
          ✋ ¿Te has reconocido?{' '}
          <span className="text-primary" data-id="element-152">
            Entonces este MegaPack es exactamente para ti.
          </span>
        </p>
      </div>
    </section>;
}